import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, imgUrl } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
    api.get(`/blog/${slug}`).then((r) => { setPost(r.data); setLoaded(true); }).catch(() => setLoaded(true));
  }, [slug]);

  if (loaded && !post) {
    return (
      <main className="pt-40 pb-32 text-center" data-testid="post-not-found">
        <p className="font-serif text-4xl mb-6">This story doesn't exist.</p>
        <Link to="/blog" className="text-[11px] uppercase tracking-[0.22em] border-b border-[#1A1A1A] pb-1">Back to Journal</Link>
      </main>
    );
  }

  return (
    <main data-testid="blog-post-page" className="pt-32 pb-28">
      {post && <Seo title={`${post.title} — Bahare`} description={post.excerpt || post.title} />}
      <article className="max-w-2xl mx-auto px-6">
        <Link to="/blog" data-testid="back-to-blog"
          className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[#7A7A7A] hover:text-[#1A1A1A] transition-colors mb-10">
          <ArrowLeft size={13} strokeWidth={1.5} /> Journal
        </Link>
        {post && (
          <Reveal>
            <p className="text-[11px] uppercase tracking-[0.2em] text-[#7A7A7A] mb-4">
              {new Date(post.created_at).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
            </p>
            <h1 className="font-serif text-4xl md:text-5xl font-light tracking-tight leading-[1.1] mb-10">{post.title}</h1>
            {post.cover_image && (
              <img src={imgUrl(post.cover_image)} alt={post.title} className="w-full h-auto mb-12" />
            )}
            <div className="space-y-6" data-testid="post-content">
              {(post.content || "").split(/\n+/).filter(Boolean).map((para, i) => (
                <p key={i} className="text-base text-[#4A4A4A] leading-[1.9]">{para}</p>
              ))}
            </div>
            <div className="mt-16 pt-10 border-t border-[#1A1A1A]/10 text-center">
              <p className="font-serif text-2xl mb-6">Enjoyed this?</p>
              <Link to="/book" data-testid="post-book-btn"
                className="inline-block bg-[#1A1A1A] text-[#F9F9F8] text-[11px] uppercase tracking-[0.22em] px-10 py-4 rounded-full hover:bg-[#4A4A4A] transition-colors">
                Book a Session
              </Link>
            </div>
          </Reveal>
        )}
      </article>
    </main>
  );
}
